import React from 'react';
import { SkeletonPage } from './Skeleton';

// Shown while a lazily loaded page (route-level code splitting) is being fetched.
export default function PageLoader() {
  return <SkeletonPage />;
}
